import { useCallback, useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export const JobControlPanel = () => {
  const [d, setD] = useState(null);
  const load = useCallback(() => {
    fetch(`${API}/api/admin/job-control`, { credentials: "include" }).then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setD).catch(() => setD({ change_orders: [], access_logs: [] }));
  }, []);
  useEffect(load, [load]);
  const decide = async (id, decision) => {
    if (decision === "approve" && !window.confirm("Approve this platform-priced change order?")) return;
    await fetch(`${API}/api/admin/change-orders/${id}/${decision}`, { method: "POST", credentials: "include" });
    load();
  };
  if (!d) return <div className="rr-muted" data-testid="job-control-loading">Loading change orders…</div>;
  return (
    <div className="rr-bids" data-testid="job-control-panel">
      <div className="rr-bids__title">Change orders · platform-priced</div>
      {d.change_orders.length === 0 && <div className="rr-muted" data-testid="job-control-co-empty">No change orders</div>}
      {d.change_orders.map((c) => (
        <div key={c.change_order_id} className="rr-bid" data-testid={`co-row-${c.change_order_id}`}>
          <div><b>{c.label}</b> · {c.quantity} {c.unit} × ${c.rate_usd} = <b>${c.amount_usd}</b></div>
          <div>{c.work_order_id} · {c.description}</div>
          <span>{c.status.replace(/_/g, " ")}</span>
          {c.status === "pending_executive_approval" && <>
            <button type="button" onClick={() => decide(c.change_order_id, "approve")} data-testid={`co-approve-${c.change_order_id}`}>Approve</button>
            <button type="button" onClick={() => decide(c.change_order_id, "decline")} data-testid={`co-decline-${c.change_order_id}`}>Decline</button>
          </>}
        </div>
      ))}
      <div className="rr-bids__title" style={{ marginTop: 8 }}>Site access log</div>
      {d.access_logs.length === 0 && <div className="rr-muted" data-testid="job-control-access-empty">No check-ins yet</div>}
      {d.access_logs.slice(0, 15).map((l) => (
        <div key={l.log_id} className="rr-bid" data-testid={`access-row-${l.log_id}`}>
          <div>{l.vendor_email} · {l.action === "check_in" ? "checked in" : "checked out"} · {l.work_order_id}</div>
          <div className="rr-muted">{new Date(l.at).toLocaleString()}{l.gps_lat ? ` · GPS ${l.gps_lat.toFixed(4)}, ${l.gps_lng.toFixed(4)}` : ""}</div>
        </div>
      ))}
    </div>
  );
};
